import { render, staticRenderFns } from "./NutritionScreening.vue?vue&type=template&id=269f6438&scoped=true"
import script from "./NutritionScreening.vue?vue&type=script&lang=js"
export * from "./NutritionScreening.vue?vue&type=script&lang=js"
import style0 from "./NutritionScreening.vue?vue&type=style&index=0&id=269f6438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f6438",
  null
  
)

export default component.exports